import * as React from 'react';
import { INavItemTopLine } from '../../types/nav';
import { IUser } from '../../types/user';
import { TDeviceType } from "@cian/ui-kit";
import { IMenuRubrics } from '../../reducers/modules/rubrics_menu/rubrics_menu';
import { NavListItem } from './nav_list_item';

import s from './nav_list.css';

interface IProps {
  deviceType: TDeviceType;
  currentUser: IUser;
  navDown?: boolean;
  navItems: IMenuRubrics[];
  activeNavItem: string;
  showNav: boolean;
  onNavigationClick(): void;
  navItemsTopLine: INavItemTopLine[];
}

class NavList extends React.Component<IProps> {
  public render() {
    const {
      currentUser,
      navItems,
      activeNavItem,
      showNav,
      onNavigationClick,
      deviceType,
      navDown,
      navItemsTopLine,
    } = this.props;

    return (
      <ul
        id="nav-submenu"
        className={`${s['navigation']} ${navDown ? s['nav-down'] : ''} ${showNav ? '' : s['navigation-hide']}`}
      >
        { navItemsTopLine.map((item, i) => (
          <li
            key={`navItemTop-${i}`}
            onClick={() => this.handleNavigationItemClick(item)}
            className={`${s['navigation__item-top-line']} ${s[item.icon]}`}
          >
            <span className={s[`navigation__item-top-line_icon`]} />
            <span className={s['navigation__item-top-line_link-text']}>
              { item.name }
            </span>
          </li>
        ))}

        <span className={s['navigation__item_top-line-delimiter']}/>

        { navItems.map((section, i) => (
          <div className={s['navigation__section']} key={i}>
            { section.items.map((item, j) => (
              <NavListItem
                key={j}
                item={item}
                activeNavItem={activeNavItem}
                currentUser={currentUser}
                deviceType={deviceType}
                onNavigationClick={onNavigationClick}
              />
            ))}
            <span className={s['navigation__item_delimiter']} />
          </div>
        ))}
      </ul>
    );
  }

  private handleNavigationItemClick(item: INavItemTopLine) {
    this.props.onNavigationClick();
    item.onSubmit();
  }
}

export { NavList }
